<div *ngIf="employerHeader" class="list-item list_rows">
    <div class="list-item-logo">
        <div class="avatar avatar-md avatar-square" [ngClass]="!employerHeader.logo ? 'monogram icon-color-default' : ''">
            <img *ngIf="employerHeader.logo" [attr.src]="employerHeader.logo" alt="">
            <i *ngIf="!employerHeader.logo" class="icn-building"></i>
        </div>
    </div>
    <div class="list-item-body">
        <div class="list-item-title flexbox">
            <div class="flex-auto">
                <h3>
                    {{employerHeader.title}}
                    <span *ngFor="let tag of employerHeader.tags" class="{{tag.styleClass}} display-mobile-none display-sm-none">{{tag.label | translate}}</span>
                </h3>
            </div>
        </div>
        <div class="list-item-columns-container">
            <div class="list-item-subtitle-list-column">
                <ng-container *ngFor="let subtitle of employerHeader.subtitles">
                    <div class="space-top-xs" [ngClass]="subtitle.styleClass">{{subtitle.label}}</div>
                </ng-container>
                <div *ngIf="employerHeader.tags && employerHeader.tags.length" class="badge-row space-top-xs">
                    <span *ngFor="let tag of employerHeader.tags" class="{{tag.styleClass}} hide display-mobile-inline-block display-sm-inline-block">{{tag.label | translate}}</span>
                </div>
            </div>
            <div *ngIf="employerHeader.buttons" class="list-item-button-column">
                <ng-container *ngFor="let button of employerHeader.buttons; index as idx">
                    <button class="btn" [ngClass]="button.styleClass" (click)="button.onClick($event, idx)">
                        <ng-container *ngIf="button.icon">
                            <i [attr.class]="button.icon"></i>
                        </ng-container>
                        {{ button.label | translate }}
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div class="padding-lg list-border">
    <h2>{{ "career_fair students.About" | translate }}</h2>
    <ul *ngIf="employerData" class="list-inline">
        <li class="space-bottom-lg display-sm-block display-mobile-block space-right-lg" *ngIf="employerData['website'] && employerData['website'] !== ''">
            <a href="{{employerData.website}}" target="_blank"><span class="icn-link"></span> {{employerData['website']}}</a>
        </li>
        <li class="space-bottom-lg display-sm-block display-mobile-block space-right-lg">
            <a href="{{empProfileUrl}}" [target]="isVirtualFair ? '_blank' : ''"><span class="icn-info"></span> {{"career_fair students.View full profile" | translate}}</a>
        </li>
        <li class="space-bottom-lg display-sm-block display-mobile-block">
            <a href="{{empJobsUrl}}" [target]="isVirtualFair ? '_blank' : ''"><span class="icn-briefcase"></span> {{"career_fair students.View all jobs" | translate}}</a>
        </li>
    </ul>

    <expandable-content
        *ngIf="employerData && employerData['overview']"
        [content]="employerData['overview']"
    >
    </expandable-content>
</div>

<div *ngIf="weAreLookingForFormConfig && employerData" class="padding-lg list-border prevent-word-overflow">
    <app-form
        id="weAreLookingForSection"
        [config]="weAreLookingForFormConfig"
        [resource]="employerData"
    >
    </app-form>
</div>


<div *ngIf="representativeInfoFormConfig" class="list-border prevent-word-overflow padding-lg">
    <h2 class="no-margin">{{ "career_fair students.Representatives" | translate }}</h2>

    <list-page
        [header]=false
        [pagination]="false"
        [displaySort]="false"
        [displayPerPage]="false"
        [autoScrollTop]="false"
        [items]="eventRepData"
        [skeleton]="skeleton"
        [styleClass]="'space-bottom-sm'"
    >
    </list-page>
</div>

<div *ngIf="otherFieldsConfig && employerData" class="padding-lg list-border prevent-word-overflow">
    <app-form
        id="otherSection"
        [config]="otherFieldsConfig"
        [resource]="employerData"
    >
    </app-form>
</div>

<div *ngIf="eventDays.length && !isVirtualFair" class="padding-lg list-border">
    <h2>{{ 'career_fair students.When and Where' | translate }}</h2>

    <when-and-where
        boothmapString="career_fair students.View booth map"
        parkingString="career_fair students.Parking Information"
        [isVirtualFair]="isVirtualFair"
        [regularFairDays]="eventDays"
        [mapSrc]="employerData.static_map_url"
        (openBoothmapModal)="onOpenBoothmapModal($event)"
        (openParkingInfoModal)="onOpenParkingInfoModal($event)"
    >
    </when-and-where>
</div>